import Box from "@mui/material/Box";
import {
  Alert,
  Button,
  CircularProgress,
  Snackbar,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { green } from "@mui/material/colors";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import { useNavigate } from "react-router-dom";
import { PostAPI } from "../../Components/Backend/PostAPI";
import SessaoAuth from "../../Hooks/SessaoAuth";
import APIAxios from "../../Api/APIAxios";


export default function ComputerRegistration() {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(5); // Computadores
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */
  const navigate = useNavigate();
  const apiAxios = APIAxios();
  const { sessao } = SessaoAuth();

  const [formData, setFormData] = useState({
      id_empresa: 0,
      id: "",
      alertas: "n",
      descricao: "",
      reg_imagem: "s",
      reg_internet: "s",
      reg_mouse: "s",
      reg_programa: "s",
      reg_teclado: "s",
      status: "n",
      tempo_imagem: 60,
      tempo_internet: 30,
      tempo_mouse: 30,
      tempo_programa: 30,
      tempo_teclado: 30,
  });

  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccess] = useState(false);

  // Abre o alerta (Snackbar) após o registro.
  const handleOpen = () => {
    setIsAlertOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setIsAlertOpen(false);
  };

  //Atualiza os dados do formulário conforme o usuário digita.
  const handleChange = (event) => {
    const { name, value } = event.target;

    const camposMaiusculos = ["descricao", "id"];

    setFormData((prevData) => ({
      ...prevData,
      [name]: camposMaiusculos.includes(name) ? value.toUpperCase() : value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setAvisoSucesso(false);
    setAvisoErro(false);

    setLoading(true);
    const response = await PostAPI(apiAxios, "/computador", formData);
    setLoading(false);

    if (response.success) {
      setAvisoSucesso(true);
      setFormData(response.data);
    } else {
      setAvisoErro(true);
      setErrorMessage(response.message || "Erro ao registrar o computador.");
    }
  };

  const handleVoltar = () => {
    navigate("/computadores");
  };

  return (
    <Box>
      <Box mt={3} mb={5}>
        <Typography variant="h4" align="center" gutterBottom>
          Novo Computador
        </Typography>
      </Box>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: 850,
          margin: "auto",
          padding: 2,
          gap: 2,
          backgroundColor: "transparent",
          borderRadius: 1,
        }}
      >
        {/* Campos de texto para entrada de dados do formulário */}
        <TextField
          label="Nome do Computador"
          name="id"
          type="text"
          value={formData.id}
          onChange={handleChange}
          required
          fullWidth
        />
        {/* Outros campos de entrada, incluindo descrição e token */}
        <TextField
          label="Descrição"
          name="descricao"
          type="text"
          value={formData.descricao}
          onChange={handleChange}
          required
          fullWidth
        />
        {/* Grupo de rádio para opção de registro do mouse */}
        <FormControl component="fieldset" required>
          <FormLabel component="legend">Registro do Mouse</FormLabel>
          <RadioGroup
            row
            name="reg_mouse"
            value={formData.reg_mouse}
            onChange={handleChange}
          >
            <FormControlLabel value="s" control={<Radio />} label="Sim" />
            <FormControlLabel value="n" control={<Radio />} label="Não" />
          </RadioGroup>
        </FormControl>

        <TextField
          label="Intervalo de Registro (segundos)"
          name="tempo_mouse"
          value={formData.tempo_mouse}
          onChange={(event) => {
            const value = event.target.value;
            if (value.length <= 4) handleChange(event); // Limita o tamanho
          }}
          required
          fullWidth
          inputProps={{ maxLength: 4 }}
        />

        {/* Grupo de rádio para opção de registro do teclado */}
        <FormControl component="fieldset" required>
          <FormLabel component="legend">Registro do Teclado</FormLabel>
          <RadioGroup
            row
            name="reg_teclado"
            value={formData.reg_teclado}
            onChange={handleChange}
          >
            <FormControlLabel value="s" control={<Radio />} label="Sim" />
            <FormControlLabel value="n" control={<Radio />} label="Não" />
          </RadioGroup>
        </FormControl>

        <TextField
          label="Intervalo de Registro (segundos)"
          name="tempo_teclado"
          value={formData.tempo_teclado}
          onChange={(event) => {
            const value = event.target.value;
            if (value.length <= 4) handleChange(event); // Limita o tamanho
          }}
          required
          fullWidth
          inputProps={{ maxLength: 4 }}
        />

        {/* Similar ao anterior, campos para registrar e indicar tempo de programa */}
        <FormControl component="fieldset" required>
          <FormLabel component="legend">Registro de Programa</FormLabel>
          <RadioGroup
            row
            name="reg_programa"
            value={formData.reg_programa}
            onChange={handleChange}
          >
            <FormControlLabel value="s" control={<Radio />} label="Sim" />
            <FormControlLabel value="n" control={<Radio />} label="Não" />
          </RadioGroup>
        </FormControl>

        <TextField
          label="Intervalo de Registro (segundos)"
          name="tempo_programa"
          value={formData.tempo_programa}
          onChange={(event) => {
            const value = event.target.value;
            if (value.length <= 4) handleChange(event); // Limita o tamanho
          }}
          required
          fullWidth
          inputProps={{ maxLength: 4 }}
        />

        {/* Campos para registro de imagem */}
        <FormControl component="fieldset" required>
          <FormLabel component="legend">Registro de Imagem</FormLabel>
          <RadioGroup
            row
            name="reg_imagem"
            value={formData.reg_imagem}
            onChange={handleChange}
          >
            <FormControlLabel value="s" control={<Radio />} label="Sim" />
            <FormControlLabel value="n" control={<Radio />} label="Não" />
          </RadioGroup>
        </FormControl>

        <TextField
          label="Intervalo de Registro (segundos)"
          name="tempo_imagem"
          value={formData.tempo_imagem}
          onChange={(event) => {
            const value = event.target.value;
            if (value.length <= 4) handleChange(event); // Limita o tamanho
          }}
          required
          fullWidth
          inputProps={{ maxLength: 4 }}
        />

        {/* Similar ao anterior, campos para registrar e indicar tempo de programa */}
        <FormControl component="fieldset" required>
          <FormLabel component="legend">Registro de Internet</FormLabel>
          <RadioGroup
            row
            name="reg_internet"
            value={formData.reg_internet}
            onChange={handleChange}
          >
            <FormControlLabel value="s" control={<Radio />} label="Sim" />
            <FormControlLabel value="n" control={<Radio />} label="Não" />
          </RadioGroup>
        </FormControl>

        <TextField
          label="Intervalo de Registro (segundos)"
          name="tempo_internet"
          value={formData.tempo_internet}
          onChange={(event) => {
            const value = event.target.value;
            if (value.length <= 4) handleChange(event); // Limita o tamanho
          }}
          required
          fullWidth
          inputProps={{ maxLength: 4 }}
        />

        {/* Botão de envio que muda de estilo quando em estado de sucesso ou carregando */}
        <Box
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            variant="contained"
            type="submit"
            onClick={handleVoltar}
            sx={{ backgroundColor: "#1a3865" }}
          >
            Voltar
          </Button>
          <Button
            variant="contained"
            type="submit"
            disabled={loading} // Desativa o botão enquanto carrega.
            sx={{ backgroundColor: "#1a3865" }}
          >
            {loading ? "Registrando..." : "Registrar Computador"}
          </Button>
          {/* Exibe o indicador de progresso circular enquanto o formulário está sendo enviado */}
          {loading && (
            <CircularProgress
              size={24}
              sx={{
                color: green[500],
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: "-12px",
                marginLeft: "-12px",
              }}
            />
          )}
        </Box>
      </Box>

      {/* Exibe uma notificação de alerta para sucesso ou erro */}
      <Snackbar
        open={isAlertOpen}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={error ? "error" : "success"}>
          {error ? errorMessage : "Computador registrado com sucesso!"}
        </Alert>
      </Snackbar>
    </Box>
  );
}
